import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "m12.785 14.556 5.328 5.344 1.416-1.415L5.415 4.33 4 5.745l5.458 5.474-5.443 5.45v3.333h3.33l5.44-5.446zM15.605 11.732l-3.327-3.337L16.41 4.26a.883.883 0 0 1 1.252 0l2.078 2.08a.886.886 0 0 1 0 1.253l-4.135 4.14z" }));
export default createSvgIcon(iconPath, "StatusUnavailable");
//# sourceMappingURL=StatusEditUnavailableIcon.js.map